import { Box, Typography } from '@mui/material';
import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getShopId, getTermofuse } from '@/entities/selectors/ShopSelectors';
import { fetchTermsOfUse } from '@/entities/slices/shop/ShopSlice';
import { AppDispatch } from '@/entities/store';
import { scrollToTop } from '@/tools/modal/scrollToTop';

import style from './LegalDocuments.module.scss';

const TermsOfUsePage = () => {
  const contentRef = useRef<HTMLDivElement>(null);
  const dispatch = useDispatch<AppDispatch>();
  const shopId = useSelector(getShopId);

  const termofuse = useSelector(getTermofuse);

  useEffect(() => {
    if (shopId) {
      void dispatch(fetchTermsOfUse({ shopId })).then(r => {
        if (contentRef.current) {
          contentRef.current.textContent = r?.payload?.data?.content ?? '';
        }
      });
    }
    scrollToTop();
  }, [shopId, dispatch]);

  return (
    <Box className={style.legalDocContainer}>
      {termofuse && (
        <Box className={style.legalDocBox}>
          <Typography className={style.legalDocTitle} variant='h1'>
            Оферта
          </Typography>
          <Box className={style.legalDocContent} ref={contentRef} style={{ whiteSpace: 'pre-wrap' }} />
        </Box>
      )}
    </Box>
  );
};
export default TermsOfUsePage;
